"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authenticateStepUpMFA = exports.initiateWebAuthnAuthentication = exports.getUserMFAStatus = exports.withdrawRequest = exports.fetchApplicationsList = exports.approveRejectRequest = exports.fetchTags = exports.getUser = exports.fetchUsers = exports.fetchMyRequestsList = void 0;

var _apiService = _interopRequireDefault(require("../utils/api-service"));

var _commonConstants = require("../utils/common-constants");

var _commonUtils = require("../utils/common-utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var fetchMyRequestsList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var payload,
        params,
        queryParams,
        listData,
        _args = arguments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            payload = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            params = {};

            if (payload.search) {
              params.filter = "status%20eq%20".concat(payload.search);
            }

            if (payload.next) {
              params.pageToken = (0, _commonUtils.getQueryParamsFromUrl)(payload.next, _commonConstants.PAGE_TOKEN);
            }

            queryParams = 'requestType=myRequests';

            if (payload.consumer) {
              queryParams = "".concat(queryParams, "&consumer=").concat(payload.consumer);
            }

            _context.next = 8;
            return _apiService.default.get("/api/v1/approvals/?".concat(queryParams), {
              params: params
            });

          case 8:
            listData = _context.sent;
            return _context.abrupt("return", listData);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchMyRequestsList() {
    return _ref.apply(this, arguments);
  };
}();

exports.fetchMyRequestsList = fetchMyRequestsList;

var fetchUsers = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _apiService.default.get('/api/users?type=User', {
              headers: {
                'content-type': 'application/json'
              }
            });

          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchUsers() {
    return _ref2.apply(this, arguments);
  };
}();

exports.fetchUsers = fetchUsers;

var getUser = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _apiService.default.get('/api/access/users');

          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getUser() {
    return _ref3.apply(this, arguments);
  };
}();

exports.getUser = getUser;

var fetchTags = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    var response;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _apiService.default.get('/api/user-tags', {
              headers: {
                'content-type': 'application/json'
              }
            });

          case 2:
            response = _context4.sent;
            return _context4.abrupt("return", response.data);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchTags() {
    return _ref4.apply(this, arguments);
  };
}();

exports.fetchTags = fetchTags;

var approveRejectRequest = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(payload) {
    var response;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _apiService.default.patch("/api/v1/approvals/".concat(payload.approvalId, "?approveRequest=").concat(payload.value), {
              approverComment: payload.commandText
            });

          case 2:
            response = _context5.sent;
            return _context5.abrupt("return", response);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function approveRejectRequest(_x) {
    return _ref5.apply(this, arguments);
  };
}();

exports.approveRejectRequest = approveRejectRequest;

var fetchApplicationsList = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
    var ApplicationsList;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _apiService.default.get("/api/apps?view=extended");

          case 2:
            ApplicationsList = _context6.sent;
            return _context6.abrupt("return", ApplicationsList.data);

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function fetchApplicationsList() {
    return _ref6.apply(this, arguments);
  };
}();

exports.fetchApplicationsList = fetchApplicationsList;

var withdrawRequest = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(requestId) {
    var response;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _apiService.default.delete("/api/v1/approvals/".concat(requestId));

          case 2:
            response = _context7.sent;
            return _context7.abrupt("return", response.data);

          case 4:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function withdrawRequest(_x2) {
    return _ref7.apply(this, arguments);
  };
}();

exports.withdrawRequest = withdrawRequest;

var getUserMFAStatus = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
    var response;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _apiService.default.get('/api/mfa/registrations?onlyAllowed=true');

          case 2:
            response = _context8.sent;
            return _context8.abrupt("return", response.data);

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function getUserMFAStatus() {
    return _ref8.apply(this, arguments);
  };
}();

exports.getUserMFAStatus = getUserMFAStatus;

var initiateWebAuthnAuthentication = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
    var response;
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return _apiService.default.post('/api/step-up/authenticate/WEB_AUTHN', {
              action: 'START_AUTHN'
            });

          case 2:
            response = _context9.sent;
            return _context9.abrupt("return", response.data);

          case 4:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function initiateWebAuthnAuthentication() {
    return _ref9.apply(this, arguments);
  };
}();

exports.initiateWebAuthnAuthentication = initiateWebAuthnAuthentication;

var authenticateStepUpMFA = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(factor) {
    var postBody,
        response,
        _args10 = arguments;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            postBody = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {};
            _context10.next = 3;
            return _apiService.default.post("/api/step-up/authenticate/".concat(factor), postBody);

          case 3:
            response = _context10.sent;
            return _context10.abrupt("return", response.data);

          case 5:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function authenticateStepUpMFA(_x3) {
    return _ref10.apply(this, arguments);
  };
}();

exports.authenticateStepUpMFA = authenticateStepUpMFA;